const setup = {
    development : {
        api_host:'http://127.0.0.1:3000'
    },
    production : { 
        api_host:'https://api.smartg.kr:3000' 
    }
}

module.exports  = setup;